const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    location: {
      type: 'object',
      title: 'location',
      properties: {
        lat: {
          type: 'string',
        },
        lng: {
          type: 'string',
        },
      },
    },
    title: {
      type: 'string',
      title: 'عنوان',
    },
    alias: {
      type: 'string',
      title: 'عنوان لاتین',
    },
    address: {
      type: 'string',
      title: 'آدرس',
    }
  },
});

export default schema;
